import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import moment from 'moment'
import {
  checkMenuPermission,
  checkFriendOneChat
} from '@/API/API'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: () => {
      if (store?.state?.token || store?.state?.token !== '') {
        return '/404'
      } else {
        return '/login'
      }
    }
  },
  {
    path: '/',
    redirect: () => {
      if (store?.state?.token || store?.state?.token !== '') {
        return localStorage.mainpage || '/dashboard'
      } else {
        return '/login'
      }
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/login',
    name: 'Login',
    // component: () => import(/* webpackChunkName: "login" */ '../views/login/Login.vue') // login
    component: () => import(/* webpackChunkName: "login" */ '../views/landingpage/LandingPageNew.vue') // landingpage
    // meta: { requiresAuth: false }
  },
  {
    path: '/loginGuest/:id',
    name: 'LoginGuest',
    component: () => import(/* webpackChunkName: "login" */ '../views/login/LoginGuest.vue')
    // meta: { requiresAuth: false }
  },
  {
    path: '/pagenotfound',
    name: 'PageNotFound',
    component: () => import(/* webpackChunkName: "page" */ '../views/pagesnotfound/Page.vue'),
    // meta: { requiresAuth: true },
    children: [
      {
        path: '/403',
        name: 'Page403',
        component: () => import(/* webpackChunkName: "403" */ '../views/pagesnotfound/403.vue')
      },
      {
        path: '/404',
        name: 'Page404',
        component: () => import(/* webpackChunkName: "404" */ '../views/pagesnotfound/404.vue')
      },
      {
        path: '/500',
        name: 'Page500',
        component: () => import(/* webpackChunkName: "500" */ '../views/pagesnotfound/500.vue')
      },
      {
        path: '/addfriend',
        name: 'AddFriendRAPlatform',
        component: () => import(/* webpackChunkName: "addraplatform" */ '../views/raplatform/AddRAPlatform.vue')
      }
    ]
  },
  {
    path: '/navbar',
    name: 'Navbar',
    component: () => import(/* webpackChunkName: "navbar" */ '../components/_layout/Navbar.vue'),
    // meta: { requiresAuth: true },
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/Dashboard.vue')
      },
      {
        path: '/orgchart',
        name: 'OrgchartOverview',
        component: () => import(/* webpackChunkName: "overview" */ '../views/manageorgchart/Overview.vue')
      },
      {
        path: '/managecompany',
        name: 'managecompany',
        component: () => import(/* webpackChunkName: "temp" */ '../views/Temp.vue'),
        children: [
          {
            path: '/managecompany',
            name: 'managecompanyview',
            // component: () => import(/* webpackChunkName: "overview" */ '../components/manageCompany/overview.vue') // เก่า
            component: () => import(/* webpackChunkName: "จัดการเครือและธุรกิจ" */ '../components/manageCreateBusiness/Overview.vue') // ใหม่
          },
          // ตารางหน้าโครงสร้าง
          {
            path: '/managecompany/structure',
            name: 'managestructureview',
            component: () => import(/* webpackChunkName: "จัดการโครงสร้าง" */ '../views/managestructurenew/OverviewDetail.vue') // ใหม่
          },
          {
            path: '/managecompany/createGroup',
            name: 'createGroup',
            // component: () => import(/* webpackChunkName: "create" */ '../components/manageCompany/groupCompany/createGroupCompany.vue') // เก่า
            component: () => import(/* webpackChunkName: "create" */ '../components/manageCreateBusiness/groupBusiness/createGroupCompany.vue') // ใหม่
          },
          // สร้างโครงสร้าง
          {
            path: '/managecompany/createstructure',
            name: 'managestructurecreate',
            component: () => import(/* webpackChunkName: "create" */ '../views/managestructurenew/Create.vue') // ใหม่
          },
          {
            path: '/managecompany/editGroup/:id', // เก่า
            // path: '/managecompany/editGroup', // ใหม่
            name: 'editGroup',
            // component: () => import(/* webpackChunkName: "create" */ '../components/manageCompany/groupCompany/editGroupCompany.vue') // เก่า
            component: () => import(/* webpackChunkName: "create" */ '../components/manageCreateBusiness/groupBusiness/editGroupCompany.vue') // ใหม่
          },
          // แก้ไขโครงสร้าง
          {
            path: '/managecompany/editstructure/:id', // เก่า
            name: 'managestructureedit',
            component: () => import(/* webpackChunkName: "edit" */ '../views/managestructurenew/Update.vue') // ใหม่
          },
          {
            path: '/managecompany/createCompany',
            name: 'createCompany',
            component: () => import(/* webpackChunkName: "create" */ '../components/manageCompany/createCompany.vue')
          },
          {
            path: '/managecompany/editCompany/:id',
            name: 'editCompany',
            component: () => import(/* webpackChunkName: "create" */ '../components/manageCompany/editCompany.vue')
          }
        ]
      },
      {
        path: '/managestructure',
        name: 'ManageStructure',
        component: () => import(/* webpackChunkName: "temp" */ '../views/managestructure/Temp.vue'), // เก่า
        children: [{
          path: '/managestructure',
          name: 'ManageStructureOverview',
          component: () => import(/* webpackChunkName: "overview" */ '../views/managestructure/OverviewDetail.vue') // เก่า
        },
        {
          path: '/managestructure/companyDetail/:id',
          name: 'ManageStructureOverviewDetail',
          component: () => import(/* webpackChunkName: "overview" */ '../views/managestructure/Overview.vue')
        },
        {
          path: '/managestructure/create',
          name: 'ManageStructureCreate',
          component: () => import(/* webpackChunkName: "create" */ '../views/managestructure/Create.vue') // เก่า
        },
        // {
        //   path: '/managestructure/create/:target',
        //   name: 'ManageStructureCreateMulti',
        //   component: () => import(/* webpackChunkName: "create" */ '../views/managestructure/Create.vue')
        // },
        {
          path: '/managestructure/update/:id',
          name: 'ManageStructureUpdate',
          component: () => import(/* webpackChunkName: "update" */ '../views/managestructure/Update.vue') // เก่า
        },
        {
          path: '/managestructure/orgchart',
          name: 'ManageStructureOrgchart',
          component: () => import(/* webpackChunkName: "orgchart" */ '../views/managestructure/Orgchart.vue')
        }]
      },
      {
        path: '/managestructureapprove',
        name: 'managestructureapprove',
        component: () => import(/* webpackChunkName: "temp" */ '../views/managestructureapprove/Temp.vue'),
        children: [{
          path: '/managestructureapprove/',
          name: 'managestructureapproveoveview',
          component: () => import(/* webpackChunkName: "view" */ '../views/managestructureapprove/Overview.vue')
        }]
      },
      {
        path: '/managelineofwork',
        name: 'ManageLineofwork',
        component: () => import(/* webpackChunkName: "temp" */ '../views/managelineofwork/Temp.vue'),
        children: [{
          path: '/managelineofwork',
          name: 'ManageLineofworkOverview',
          component: () => import(/* webpackChunkName: "overview" */ '../views/managelineofwork/Overview.vue')
        }, {
          path: '/managelineofwork/create',
          name: 'ManageLineofworkCreate',
          component: () => import(/* webpackChunkName: "create" */ '../views/managelineofwork/Create.vue')
        }, {
          path: '/managelineofwork/update',
          name: 'ManageLineofworkUpdate',
          component: () => import(/* webpackChunkName: "update" */ '../views/managelineofwork/Update.vue')
        }, {
          path: '/managelineofwork/orgchart',
          name: 'ManageLineofworkOrgchart',
          component: () => import(/* webpackChunkName: "orgchart" */ '../views/managelineofwork/Orgchart.vue')
        }]
      },
      {
        path: '/manageagency',
        name: 'manageAgency',
        component: () => import(/* webpackChunkName: "temp" */ '../views/manageagency/Temp.vue'),
        children: [{
          path: '/manageagency/',
          name: 'manageAgencyView',
          component: () => import(/* webpackChunkName: "view" */ '../views/manageagency/Overview.vue')
        }, {
          path: '/manageagency/create',
          name: 'manageAgencyCreate',
          component: () => import(/* webpackChunkName: "create" */ '../views/manageagency/Create.vue')
        }, {
          path: '/manageagency/update',
          name: 'manageAgencyUpdate',
          component: () => import(/* webpackChunkName: "update" */ '../views/manageagency/Update.vue')
        }]
      },
      {
        path: '/manageworkgroup',
        name: 'manageWorkgroup',
        component: () => import(/* webpackChunkName: "temp" */ '../views/manageworkgroup/Temp.vue'),
        children: [{
          path: '/manageworkgroup/',
          name: 'manageWorkgroupView',
          component: () => import(/* webpackChunkName: "view" */ '../views/manageworkgroup/Overview.vue')
        }, {
          path: '/manageworkgroup/create',
          name: 'manageWorkgroupCreate',
          component: () => import(/* webpackChunkName: "create" */ '../views/manageworkgroup/Create.vue')
        }, {
          path: '/manageworkgroup/update',
          name: 'manageWorkgroupUpdate',
          component: () => import(/* webpackChunkName: "update" */ '../views/manageworkgroup/Update.vue')
        }]
      },
      {
        path: '/manageposition',
        name: 'managePosition',
        component: () => import(/* webpackChunkName: "temp" */ '../views/manageposition/Temp.vue'),
        children: [{
          path: '/manageposition/',
          name: 'managePositionView',
          component: () => import(/* webpackChunkName: "view" */ '../views/manageposition/Overview.vue')
        },
        {
          path: '/manageposition/create',
          name: 'managePositionCreate',
          component: () => import(/* webpackChunkName: "create" */ '../views/manageposition/Create.vue')
        },
        {
          path: '/manageposition/update',
          name: 'managePositionUpdate',
          component: () => import(/* webpackChunkName: "update" */ '../views/manageposition/Update.vue')
        }]
      },
      {
        path: '/manageprofile',
        name: 'manageProfile',
        component: () => import(/* webpackChunkName: "temp" */ '../views/manageprofile/Temp.vue'),
        children: [{
          path: '/manageprofile/',
          name: 'manageProfileView',
          component: () => import(/* webpackChunkName: "view" */ '../views/manageprofile/Overview.vue')
        }]
      },
      {
        path: '/manageparticipation',
        name: 'manageParticipation',
        component: () => import(/* webpackChunkName: "temp" */ '../views/manageparticipation/Temp.vue'),
        children: [{
          path: '/manageparticipation/',
          name: 'manageParticipationView',
          // component: () => import(/* webpackChunkName: "view" */ '../views/manageprofile/Overview.vue')
          component: () => import(/* webpackChunkName: "view" */ '../views/manageparticipation/Overview.vue')
        }]
      },
      {
        path: '/managesection',
        name: 'manageSection',
        component: () => import(/* webpackChunkName: "temp" */ '../views/managesection/Temp.vue'),
        children: [{
          path: '/managesection/',
          name: 'manageSectionView',
          component: () => import(/* webpackChunkName: "view" */ '../views/managesection/Overview.vue')
        }, {
          path: '/managesection/create',
          name: 'manageSectionCreate',
          component: () => import(/* webpackChunkName: "create" */ '../views/managesection/Create.vue')
        },
        {
          path: '/managesection/update',
          name: 'manageSectionUpdate',
          component: () => import(/* webpackChunkName: "update" */ '../views/managesection/Update.vue')
        }]
      },
      {
        path: '/managedepartment',
        name: 'manageDepartment',
        component: () => import(/* webpackChunkName: "temp" */ '../views/managedepartment/Temp.vue'),
        children: [{
          path: '/managedepartment/',
          name: 'manageDepartmentView',
          component: () => import(/* webpackChunkName: "view" */ '../views/managedepartment/Overview.vue')
        }, {
          path: '/managedepartment/create',
          name: 'manageDepartmentCreate',
          component: () => import(/* webpackChunkName: "create" */ '../views/managedepartment/Create.vue')
        }, {
          path: '/managedepartment/update',
          name: 'ManageDepartmentUpdate',
          component: () => import(/* webpackChunkName: "update" */ '../views/managedepartment/Update.vue')
        }]
      },
      {
        path: '/manageemployee',
        name: 'manageEmployee',
        component: () => import(/* webpackChunkName: "temp" */ '../views/manageemployee/Temp.vue'),
        children: [{
          path: '/manageemployee/',
          name: 'manageEmployeeView',
          component: () => import(/* webpackChunkName: "view" */ '../views/manageemployee/Overview.vue')
        }, {
          path: '/manageemployee/create',
          name: 'manageEmployeeCreate',
          component: () => import(/* webpackChunkName: "create" */ '../views/manageemployee/Create.vue')
        },
        {
          path: '/manageemployee/update/:tab/:id',
          name: 'manageEmployeeUpdate',
          component: () => import(/* webpackChunkName: "update" */ '../views/manageemployee/Update.vue')
        },
        {
          path: '/manageemployee/import',
          name: 'manageEmployeeImport',
          component: () => import(/* webpackChunkName: "import" */ '../views/manageemployee/Import.vue')
        }]
      },
      {
        path: '/authorityservices',
        name: 'authorityservices',
        component: () => import(/* webpackChunkName: "temp" */ '../views/authorityservices/Temp.vue'),
        children: [
          // {
          //   path: '/authorityservices/:page',
          //   name: 'authorityservicesMain',
          //   component: () => import(/* webpackChunkName: "view" */ '../views/authorityservices/Overview.vue')
          // },
          {
            path: '/authorityservices/myservicelist',
            name: 'authorityservicesMain',
            component: () => import(/* webpackChunkName: "view" */ '../views/authorityservices/Overview.vue')
          },
          {
            path: '/authorityservices/myservicelist/:id',
            name: 'authorityservicesShow',
            component: () => import(/* webpackChunkName: "view" */ '../views/authorityservices/ShowMyservice.vue')
          },
          {
            path: '/authorityservices/myservicelist/create',
            name: 'authorityservicesCreate',
            component: () => import(/* webpackChunkName: "create" */ '../views/authorityservices/Create.vue')
          },
          {
            path: '/authorityservices/requestservicelist',
            name: 'authorityservicesRequestservicelist',
            component: () => import(/* webpackChunkName: "view" */ '../views/authorityservices/RequestService.vue')
          }
        ]
      },
      {
        path: '/settingservices',
        name: 'settingservices',
        component: () => import(/* webpackChunkName: "temp" */ '../views/authorityservices/Temp.vue'),
        children: [
          {
            path: '/settingservices',
            name: 'settingservicesview',
            component: () => import(/* webpackChunkName: "view" */ '../views/authorityservices/settingService.vue')
          },
          {
            path: '/settingservices/createservice',
            name: 'createservice',
            component: () => import(/* webpackChunkName: "create" */ '../views/authorityservices/CreateService.vue')
          },
          {
            path: '/settingservices/update/:id',
            name: 'updateServicesDetail',
            component: () => import(/* webpackChunkName: "update" */ '../views/authorityservices/Update.vue')
          }
        ]
      },
      {
        path: '/manageapprove',
        name: 'manageapprove',
        component: () => import(/* webpackChunkName: "temp" */ '../views/manageapprove/Temp.vue'),
        children: [{
          path: '/manageapprove/',
          name: 'manageapproveview',
          component: () => import(/* webpackChunkName: "view" */ '../views/manageapprove/Overview.vue')
        },
        {
          path: '/manageapprove/update',
          name: 'manageapproveupdate',
          component: () => import(/* webpackChunkName: "update" */ '../views/manageapprove/Update.vue')
        }]
      },
      {
        path: '/manageapprovecompany',
        name: 'manageapproveCompany',
        component: () => import(/* webpackChunkName: "temp" */ '../views/manageapprovecompany/Temp.vue'),
        children: [{
          path: '/manageapprovecompany/',
          name: 'manageapprovecompanyview',
          component: () => import(/* webpackChunkName: "view" */ '../views/manageapprovecompany/Overview.vue')
        },
        {
          path: '/manageapprovecompany/create',
          name: 'manageapproveCompanycreate',
          component: () => import(/* webpackChunkName: "create" */ '../views/manageapprovecompany/Create.vue')
        },
        {
          path: '/manageapprovecompany/update/:id',
          name: 'manageapproveCompanyupdate',
          component: () => import(/* webpackChunkName: "update" */ '../views/manageapprovecompany/Update.vue')
        }]
      },
      // // ###################################### * OLD manageapprovebusiness * ####################################################
      {
        path: '/manageapprovebusiness',
        name: 'manageapproveBusiness',
        // component: () => import(/* webpackChunkName: "temp" */ '../views/manageapprovebusiness/Temp.vue'), // เก่า
        component: () => import(/* webpackChunkName: "temp" */ '../views/manageapprovebusinessnew/Temp.vue'), // ใหม่
        children: [{
          path: '/manageapprovebusiness/',
          name: 'manageapprovebusinessview',
          // component: () => import(/* webpackChunkName: "view" */ '../views/manageapprovebusiness/Overview.vue') // เก่า
          component: () => import(/* webpackChunkName: "view" */ '../views/manageapprovebusinessnew/Overview.vue') // ใหม่
        },
        {
          path: '/manageapprovebusiness/create',
          name: 'manageapproveBusinesscreate',
          // component: () => import(/* webpackChunkName: "create" */ '../views/manageapprovebusiness/Create.vue') // เก่า
          component: () => import(/* webpackChunkName: "create" */ '../views/manageapprovebusinessnew/Create.vue') // ใหม่
        },
        {
          path: '/manageapprovebusiness/update/:id',
          name: 'manageapproveBusinessupdate',
          // component: () => import(/* webpackChunkName: "update" */ '../views/manageapprovebusiness/Update.vue') // เก่า
          component: () => import(/* webpackChunkName: "update" */ '../views/manageapprovebusinessnew/Update.vue') // ใหม่
        }]
      },
      // ###################################### * NEW manageapprovebusiness * ####################################################
      // {
      //   path: '/manageapprovebusinessnew',
      //   name: 'manageapproveBusiness',
      //   component: () => import(/* webpackChunkName: "temp" */ '../views/manageapprovebusinessnew/Temp.vue'),
      //   children: [{
      //     path: '/manageapprovebusinessnew/',
      //     name: 'manageapproveview',
      //     component: () => import(/* webpackChunkName: "view" */ '../views/manageapprovebusinessnew/Overview.vue')
      //   },
      //   {
      //     path: '/manageapprovebusinessnew/create',
      //     name: 'manageapproveBusinesscreate',
      //     component: () => import(/* webpackChunkName: "create" */ '../views/manageapprovebusinessnew/Create.vue')
      //   },
      //   {
      //     path: '/manageapprovebusinessnew/update/:id',
      //     name: 'manageapproveBusinessupdate',
      //     component: () => import(/* webpackChunkName: "update" */ '../views/manageapprovebusinessnew/Update.vue')
      //   }]
      // },
      // // ###############################################################################################################
      {
        path: '/manageapprovetoken',
        name: 'manageapproveToken',
        component: () => import(/* webpackChunkName: "temp" */ '../views/manageapprovetoken/Temp.vue'),
        children: [{
          path: '/manageapprovetoken/',
          name: 'manageapprovetokenview',
          component: () => import(/* webpackChunkName: "view" */ '../views/manageapprovetoken/Overview.vue')
        },
        {
          path: '/manageapprovetoken/create',
          name: 'manageapproveTokencreate',
          component: () => import(/* webpackChunkName: "create" */ '../views/manageapprovetoken/Create.vue')
        },
        {
          path: '/manageapprovetoken/updateManage/:id',
          name: 'manageapproveTokenupdateManage',
          component: () => import(/* webpackChunkName: "update" */ '../views/manageapprovetoken/UpdateManage.vue')
        },
        {
          path: '/manageapprovetoken/update/:id',
          name: 'manageapproveTokenupdate',
          component: () => import(/* webpackChunkName: "update" */ '../views/manageapprovetoken/Update.vue')
        }]
      },
      // จัดการธุรกิจ
      {
        path: '/managebusines',
        name: 'manageBusines',
        // component: () => import(/* webpackChunkName: "temp" */ '../views/managebusiness/Temp.vue'), // เก่า
        component: () => import(/* webpackChunkName: "temp" */ '../views/managebusinessnew/Temp.vue'), // ใหม่
        children: [{
          path: '/managebusines/',
          name: 'managebusinesview',
          // component: () => import(/* webpackChunkName: "view" */ '../views/managebusiness/Overview.vue')// เก่า
          component: () => import(/* webpackChunkName: "view" */ '../views/managebusinessnew/Overview.vue') // ใหม่
        },
        {
          path: '/managebusines/create',
          name: 'manageBusinescreate',
          // component: () => import(/* webpackChunkName: "create" */ '../views/managebusiness/Create.vue') // เก่า
          component: () => import(/* webpackChunkName: "create" */ '../views/managebusinessnew/Create.vue') // ใหม่
        },
        {
          path: '/managebusines/updateBusiness/:id',
          name: 'manageBusinesupdateBusiness',
          // component: () => import(/* webpackChunkName: "update" */ '../views/managebusiness/UpdateBusiness.vue') // เก่า
          component: () => import(/* webpackChunkName: "update" */ '../views/managebusinessnew/UpdateBusiness.vue') // ใหม่
        },
        {
          path: '/managebusines/update/:id',
          name: 'manageBusinesupdate',
          // component: () => import(/* webpackChunkName: "update" */ '../views/managebusiness/Update.vue') // เก่า
          component: () => import(/* webpackChunkName: "update" */ '../views/managebusinessnew/Update.vue') // ใหม่
        }]
      },
      {
        path: '/managetransferrole',
        name: 'manageTransferrole',
        component: () => import(/* webpackChunkName: "temp" */ '../views/managetransferrole/Temp.vue'),
        children: [{
          path: '/managetransferrole/',
          name: 'managetransferroleview',
          component: () => import(/* webpackChunkName: "view" */ '../views/managetransferrole/Overview.vue')
        },
        {
          path: '/managetransferrole/create',
          name: 'manageTransferrolecreate',
          component: () => import(/* webpackChunkName: "create" */ '../views/managetransferrole/Create.vue')
        },
        {
          path: '/managetransferrole/createTransferrole/:id/:orgchartId',
          name: 'manageTransferrolecreateTransferrole',
          component: () => import(/* webpackChunkName: "create" */ '../views/managetransferrole/CreateTransferrole.vue')
        },
        {
          path: '/managetransferrole/updateTag/:id',
          name: 'manageTransferroletagupdate',
          component: () => import(/* webpackChunkName: "update" */ '../views/managetransferrole/UpdateTag.vue')
        },
        {
          path: '/managetransferrole/updateHistory/:id/:orgchartId',
          name: 'manageTransferroleupdateHistory',
          component: () => import(/* webpackChunkName: "update" */ '../views/managetransferrole/UpdateHistory.vue')
        },
        {
          path: '/managetransferrole/updateSubrole/:id/:orgchartId',
          name: 'manageTransferroleupdateSubrole',
          component: () => import(/* webpackChunkName: "update" */ '../views/managetransferrole/UpdateSubrole.vue')
        },
        {
          path: '/managetransferrole/update/:id/:orgchartId',
          name: 'manageTransferroleupdate',
          component: () => import(/* webpackChunkName: "update" */ '../views/managetransferrole/Update.vue')
        }]
      },
      {
        path: '/manageapprovetransferrole',
        name: 'manageApprovetransferrole',
        component: () => import(/* webpackChunkName: "temp" */ '../views/manageapprovetransferrole/Temp.vue'),
        children: [{
          path: '/manageapprovetransferrole/',
          name: 'manageapprovetransferroleview',
          component: () => import(/* webpackChunkName: "view" */ '../views/manageapprovetransferrole/Overview.vue')
          // component: () => import(/* webpackChunkName: "view" */ '../views/managetransferrole/Overview.vue')
        },
        {
          path: '/manageapprovetransferrole/update/:id',
          name: 'manageapprovetransferroleupdate',
          component: () => import(/* webpackChunkName: "update" */ '../views/manageapprovetransferrole/Update.vue')
        }]
      },
      {
        path: '/manageapproveparticipation',
        name: 'manageApproveparticipation',
        component: () => import(/* webpackChunkName: "temp" */ '../views/manageapproveparticipation/Temp.vue'),
        children: [{
          path: '/manageapproveparticipation/',
          name: 'manageapproveparticipationview',
          component: () => import(/* webpackChunkName: "view" */ '../views/manageapproveparticipation/Overview.vue')
          // component: () => import(/* webpackChunkName: "view" */ '../views/managetransferrole/Overview.vue')
        },
        {
          path: '/manageapproveparticipation/update/:id',
          name: 'manageParticipationupdate',
          component: () => import(/* webpackChunkName: "update" */ '../views/manageapproveparticipation/Update.vue')
        }]
      },
      // {
      //   path: '/manageregiscompany',
      //   name: 'manageregisCompany',
      //   component: () => import(/* webpackChunkName: "temp" */ '../views/manageregiscompany/Temp.vue'),
      //   children: [{
      //     path: '/manageregiscompany/',
      //     name: 'manageregisview',
      //     component: () => import(/* webpackChunkName: "view" */ '../views/manageregiscompany/Overview.vue')
      //   },
      //   {
      //     path: '/manageregiscompany/create',
      //     name: 'manageregiscreate',
      //     component: () => import(/* webpackChunkName: "create" */ '../views/manageregiscompany/Create.vue')
      //   }]
      // },
      {
        path: '/manageapprovelist',
        name: 'manageapprovelist',
        component: () => import(/* webpackChunkName: "temp" */ '../views/manageapprovelist/Temp.vue'),
        children: [{
          path: '/manageapprovelist/',
          name: 'manageapprovelistview',
          component: () => import(/* webpackChunkName: "view" */ '../views/manageapprovelist/Overview.vue')
        },
        {
          path: '/manageapprovelist/update',
          name: 'manageapprovelistupdate',
          component: () => import(/* webpackChunkName: "update" */ '../views/manageapprovelist/Update.vue')
        }]
      },
      // beforeEnter: (to, from, next) => {
      //   if (!(store.state.user.role).includes('administrator')) {
      //     console.log('not admin')
      //     next('/dashboard')
      //   } else {
      //     // console.log('is admin')
      //     next(true)
      //   }
      // }
      {
        path: '/managerole',
        name: 'manageRole',
        component: () => import(/* webpackChunkName: "temp" */ '../views/managerole/Temp.vue'),
        children: [{
          path: '/managerole/',
          name: 'manageRoleView',
          component: () => import(/* webpackChunkName: "view" */ '../views/managerole/Overview.vue')
        }, {
          path: '/managerole/create',
          name: 'manageRoleCreate',
          component: () => import(/* webpackChunkName: "create" */ '../views/managerole/Create.vue')
        },
        {
          path: '/managerole/update/:id',
          name: 'manageRoleUpdate',
          component: () => import(/* webpackChunkName: "update" */ '../views/managerole/Update.vue')
        }]
      },
      {
        path: '/managerolecompany',
        name: 'manageRoleCompany',
        component: () => import(/* webpackChunkName: "temp" */ '../views/managerolecompany/Temp.vue'),
        children: [{
          path: '/managerolecompany/',
          name: 'manageRoleCompanyView',
          component: () => import(/* webpackChunkName: "view" */ '../views/managerolecompany/Overview.vue')
        }, {
          path: '/managerolecompany/create',
          name: 'manageRoleCompanyCreate',
          component: () => import(/* webpackChunkName: "create" */ '../views/managerolecompany/Create.vue')
        },
        {
          path: '/managerolecompany/createGroup',
          name: 'manageRoleCompanyCreateGroup',
          component: () => import(/* webpackChunkName: "create" */ '../views/managerolecompany/CreateGroup.vue')
        },
        {
          path: '/managerolecompany/createPerson',
          name: 'manageRoleCompanyCreatePerson',
          component: () => import(/* webpackChunkName: "create" */ '../views/managerolecompany/CreatePerson.vue')
        },
        {
          path: '/managerolecompany/update/:id',
          name: 'manageRoleCompanyUpdate',
          component: () => import(/* webpackChunkName: "update" */ '../views/managerolecompany/Update.vue')
        },
        {
          path: '/managerolecompany/updateGroup/:id',
          name: 'manageRoleCompanyUpdateGroup',
          component: () => import(/* webpackChunkName: "update" */ '../views/managerolecompany/UpdateGroup.vue')
        },
        {
          path: '/managerolecompany/updatePerson/:id',
          name: 'manageRoleCompanyUpdatePerson',
          component: () => import(/* webpackChunkName: "update" */ '../views/managerolecompany/UpdatePerson.vue')
        }]
      },
      {
        path: '/manageroleapprover',
        name: 'manageroleapprover',
        component: () => import(/* webpackChunkName: "temp" */ '../views/manageroleapprover/Temp.vue'),
        children: [
          {
            path: '/manageroleapprover/',
            name: 'manageroleapproverview',
            component: () => import(/* webpackChunkName: "view" */ '../views/manageroleapprover/Main.vue')
          },
          {
            path: '/manageroleapprover/c/:id',
            name: 'manageroleapproverCompany',
            component: () => import(/* webpackChunkName: "view" */ '../views/manageroleapprover/Overview.vue'),
            props: true
          },
          {
            path: '/manageroleapprover/create',
            name: 'manageroleapproverCreate',
            component: () => import(/* webpackChunkName: "create" */ '../views/manageroleapprover/Create.vue')
          },
          {
            path: '/manageroleapprover/create/:id',
            name: 'manageroleapproverCreateByComp',
            component: () => import(/* webpackChunkName: "create" */ '../views/manageroleapprover/Create.vue')
          },
          {
            path: '/manageroleapprover/update/:id',
            name: 'manageroleapproverUpdateById',
            component: () => import(/* webpackChunkName: "update" */ '../views/manageroleapprover/Update.vue')
          },
          {
            path: '/manageroleapprover/assign/:id',
            name: 'manageroleapproverAssign',
            component: () => import(/* webpackChunkName: "create" */ '../views/manageroleapprover/Assign.vue')
          }
        ]
      },
      // Template page (**** ตัวแบบมาจากหน้า จัดการเครือและบริษัท update 9/3/66 ****)
      {
        path: '/orgadminmanagement',
        name: 'orgAdminmanagement',
        component: () => import(/* webpackChunkName: "temp" */ '../views/Temp.vue'),
        children: [
          {
            path: '/orgadminmanagement',
            name: 'orgAdminmanagementView',
            component: () => import(/* webpackChunkName: "โครงหน้าหลัก" */ '../components/manageTemplate/_overview/Overview.vue')
          }
          // {
          //   path: '/managetemplate/create',
          //   name: 'managetemplateCreate',
          //   component: () => import(/* webpackChunkName: "create" */ '../components/manageTemplate/_create/create.vue')
          // }
        ]
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// async function checkPermission(to, from, next) {
//   var getAccess = await checkMenuPermission({ link: link }, store.state.token)
//   // console.log(to.path.split('/'), getAccess)
//   if (getAccess.success) {
//     if (getAccess.result.access) {
//       return ''
//     } else {
//       if (getAccess.result.code === 'link not found') {
//         return '/404'
//       } else {
//         return '/403'
//       }
//     }
//   } else {
//     return '/500'
//   }
// }

router.beforeEach(async (to, from, next) => {
  // console.log('to, from', to, from)
  // if (!(['/login', '/403', '/404', '/500'].includes(to.path))) {
  if (!([!to.params.id ? '/login' : '/loginGuest/' + to.params.id, '/403', '/404', '/500'].includes(to.path))) {
    if (store.state.token && store.state.token !== '') {
      localStorage.setItem('targetpath', '')
      if (store.state.expiresToken) {
        // CHECK TOKEN EXPIRE
        var expiresDate = moment(store.state.expiresToken, 'DD-MM-YYYY HH:mm:ss').valueOf()
        var now = moment().valueOf()
        if (now > expiresDate) {
          next(!to.params.id ? '/login' : '/loginGuest/' + to.params.id)
        } else {
          if (to.path !== '/addfriend' && to.path === '/login') {
            if (store.state.userRole === 'user') {
              if (localStorage.addedFriendOneChat === undefined || localStorage.addedFriendOneChat === false || localStorage.addedFriendOneChat === '') {
                var getFriendOneChat = await checkFriendOneChat({ oneMail: store.state.user.emailOneId }, store.state.token)
                if (getFriendOneChat.status === 'success') {
                  localStorage.setItem('addedFriendOneChat', 'true')
                } else {
                  localStorage.setItem('addedFriendOneChat', 'false')
                }
              }
              if (localStorage.addedFriendOneChat === 'true') {
                const spacialList = ['/authorityservices', '/managestructure', '/managestructureapprove']
                const lastToMatched = to.matched.slice(-1).pop()
                var link = lastToMatched.path.includes('managestructure')
                  ? '/managestructure' : lastToMatched.path.includes('/:')
                    ? to.path : lastToMatched.parent.path === '/navbar'
                      ? to.path : spacialList.includes(lastToMatched.parent.path)
                        ? `/${to.path.split('/')[1]}/${to.path.split('/')[2]}` : lastToMatched.parent.path
                // console.log('target link', link, to.path, lastToMatched)
                // console.log('target link 2', to.path)
                if (link === '/authorityservices/approverequest') link = '/authorityservices/myservicelist'
                const getAccess = await checkMenuPermission({ link: link }, store.state.token)
                if (getAccess.success) {
                  if (getAccess.result.access) {
                    window.scrollTo(0, 0)
                    next()
                  } else {
                    if (getAccess.result.code === 'link not found') {
                      next('/404')
                    } else {
                      next('/403')
                    }
                  }
                } else {
                  next('/500')
                }
              } else if (localStorage.addedFriendOneChat === 'false') {
                next('/addfriend')
              } else {
                next('/500')
              }
            } else {
              const spacialList = ['/authorityservices', '/managestructure']
              const lastToMatched = to.matched.slice(-1).pop()
              const link = lastToMatched.path.includes('managestructure')
                ? '/managestructure' : lastToMatched.path.includes('/:')
                  ? to.path : lastToMatched.parent.path === '/navbar'
                    ? to.path : spacialList.includes(lastToMatched.parent.path)
                      ? `/${to.path.split('/')[1]}/${to.path.split('/')[2]}` : lastToMatched.parent.path
              const getAccess = await checkMenuPermission({ link: link }, store.state.token)
              if (getAccess.success) {
                if (getAccess.result.access) {
                  window.scrollTo(0, 0)
                  next()
                } else {
                  if (getAccess.result.code === 'link not found') {
                    next('/404')
                  } else {
                    next('/403')
                  }
                }
              } else {
                next('/500')
              }
            }
          } else {
            window.scrollTo(0, 0)
            next()
          }
        }
      }
    } else {
      next(!to.params.id ? '/login' : '/loginGuest/' + to.params.id)
    }
  } else {
    window.scrollTo(0, 0)
    next()
  }
})

// เอาไว้ทำ permission route
// router.afterEach(async (to, from, next) => {
//   console.log('afterEach to, from', to, from)
//   const hasPermissions = store?.state?.permissions && store?.state?.permissions.length > 0
//   if (!hasPermissions) {
//     try {
//       await store.dispatch('fetchPermissions')
//       // หลังจากได้ข้อมูลสิทธิ์แล้ว ค่อยเช็คเงื่อนไขการเข้าหน้าจอที่ต้องการสิทธิ์
//       console.log('Permissions fetched:', store.state.permissions)
//       if (to.meta.permissions && !store.getters.access(to.meta.permissions)) {
//         // ถ้าไม่มีสิทธิ์เข้าถึงหน้าจอนั้น ให้ไปที่หน้า 403
//         next('/403')
//       } else {
//         // ถ้ามีสิทธิ์เข้าถึงหน้าจอนั้น ให้ไปหน้าจอที่ต้องการ
//         next()
//       }
//     } catch (error) {
//       console.error('Error fetching permissions:', error)
//       next('/login')
//     }
//   } else {
//     next()
//   }
// })

export default router
